interface AttachmentItem {
  file: File
  url: string
  type: string
  name: string
}

interface AttachmentsPreviewProps {
  attachments: AttachmentItem[]
  onRemove: (index: number) => void
}

function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

export function AttachmentsPreview({ attachments, onRemove }: AttachmentsPreviewProps) {
  if (attachments.length === 0) return null

  return (
    <div className="flex gap-2 overflow-x-auto px-4 py-2">
      {attachments.map((att, index) => (
        <div
          key={`${att.name}-${index}`}
          className="flex items-center gap-2 rounded-lg border border-(--color-border) bg-(--color-bg-secondary) p-2 min-w-[200px] max-w-[240px]"
        >
          {/* Thumbnail or icon */}
          <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded">
            {att.type.startsWith('image/') ? (
              <img
                src={att.url}
                alt={att.name}
                className="h-10 w-10 rounded object-cover"
              />
            ) : att.type.startsWith('audio/') ? (
              <span className="text-xl">🎵</span>
            ) : (
              <span className="text-xl">📄</span>
            )}
          </div>

          {/* File info */}
          <div className="flex-1 min-w-0 overflow-hidden">
            <p className="truncate text-xs font-medium text-(--color-text-primary)">
              {att.name}
            </p>
            <p className="text-xs text-(--color-text-muted)">
              {formatBytes(att.file.size)}
            </p>
          </div>

          {/* Remove button */}
          <button
            onClick={() => onRemove(index)}
            className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-(--color-text-muted) hover:bg-(--color-bg-tertiary) hover:text-(--color-danger) transition-colors"
            title="Remover"
          >
            <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  )
}
